import { PlaceholdersId, TFComponent } from '@types';
import { EnterpriseSolutionPlaceholder } from './enterpriseSolution';

export const enterpriseSolution: TFComponent = {
	component: EnterpriseSolutionPlaceholder,
	id: PlaceholdersId.enterpriseSolution,
	name: 'enterpriseSolution',
};
